/*! react-grid-system v1.1.0 | (c) 2019 Trend Micro Inc. | MIT | https://github.com/trendmicro-frontend/react-grid-system */
module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/index.js");
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  "./src/Col.jsx":
  /*!*********************!*\
    !*** ./src/Col.jsx ***!
    \*********************/

  /*! exports provided: default */

  /***/
  function srcColJsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! classnames */
    "classnames");
    /* harmony import */


    var classnames__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! prop-types */
    "prop-types");
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
    /*#__PURE__*/
    __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_2___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */


    var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
    /*! ./constants */
    "./src/constants.js");
    /* harmony import */


    var _Resolver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
    /*! ./Resolver */
    "./src/Resolver.jsx");
    /* harmony import */


    var _index_styl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
    /*! ./index.styl */
    "./src/index.styl");
    /* harmony import */


    var _index_styl__WEBPACK_IMPORTED_MODULE_5___default =
    /*#__PURE__*/
    __webpack_require__.n(_index_styl__WEBPACK_IMPORTED_MODULE_5__);

    function _typeof(obj) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
          return typeof obj;
        };
      } else {
        _typeof = function _typeof(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }

      return _typeof(obj);
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);

      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
      }

      return keys;
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};

        if (i % 2) {
          ownKeys(source, true).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(source).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }

      return target;
    }

    function _objectWithoutProperties(source, excluded) {
      if (source == null) return {};

      var target = _objectWithoutPropertiesLoose(source, excluded);

      var key, i;

      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
          target[key] = source[key];
        }
      }

      return target;
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var flexboxAutoprefixer = function flexboxAutoprefixer(style) {
      return Object.keys(style).reduce(function (obj, key) {
        var val = style[key];

        if (key === 'flex') {
          // flex: 1 0 50%;
          style.WebkitBoxFlex = parseInt(val, 10); // -webkit-box-flex

          style.WebkitFlex = val; // -webkit-flex

          style.msFlex = val; // -ms-flex
        } else if (key === 'flexBasis') {
          style.WebkitFlexBasis = val; // -webkit-flex-basis;

          style.msFlexPreferredSize = val; // -ms-flex-preferred-size
        } else if (key === 'flexGrow') {
          style.WebkitBoxFlex = val; // -webkit-box-flex

          style.WebkitFlexGrow = val; // -webkit-flex-grow

          style.msFlexPositive = val; // -ms-flex-positive
        }

        if (key === 'flexShrink') {
          obj.WebkitFlexShrink = val; // -webkit-flex-shrink

          obj.msFlexNegative = val; // -ms-flex-negative
        }

        obj[key] = val;
        return obj;
      }, {});
    };

    var getWidth = function getWidth(width, columns) {
      if (width === 'auto') {
        return width;
      }

      width = parseInt(width, 10);

      if (Number.isNaN(width)) {
        return undefined;
      }

      columns = Math.floor(columns);

      if (columns <= 0) {
        columns = 1;
      }

      var colWidth = Math.max(0, Math.min(columns, width));

      if (colWidth === columns) {
        return '100%';
      }

      return "".concat((100 / columns * colWidth).toFixed(8) * 1, "%");
    };

    var Col =
    /*#__PURE__*/
    function (_Component) {
      _inherits(Col, _Component);

      function Col() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Col);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Col)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "getFloatsStyle", function (_ref) {
          var columns = _ref.columns,
              gutterWidth = _ref.gutterWidth,
              screenClass = _ref.screenClass;
          var style = {
            boxSizing: 'border-box',
            paddingLeft: gutterWidth / 2,
            paddingRight: gutterWidth / 2
          };

          if (_this.props.width) {
            style.width = getWidth(_this.props.width, columns) || style.width;
          }

          var width = {
            xs: _this.props.xs,
            sm: _this.props.sm,
            md: _this.props.md,
            lg: _this.props.lg,
            xl: _this.props.xl,
            xxl: _this.props.xxl
          };
          var _this$props = _this.props,
              offset = _this$props.offset,
              push = _this$props.push,
              pull = _this$props.pull;
          var screenClasses = _constants__WEBPACK_IMPORTED_MODULE_3__["SCREEN_CLASSES"];
          screenClasses.forEach(function (size, index) {
            if (screenClasses.indexOf(screenClass) < index) {
              return;
            }

            style.width = getWidth(width[size], columns) || style.width;
            style.marginLeft = getWidth(offset[size], columns) || style.marginLeft;
            style.left = getWidth(push[size], columns) || style.left;
            style.right = getWidth(pull[size], columns) || style.right;
          });
          return style;
        });

        _defineProperty(_assertThisInitialized(_this), "getFlexboxStyle", function (_ref2) {
          var columns = _ref2.columns,
              gutterWidth = _ref2.gutterWidth,
              screenClass = _ref2.screenClass;
          var style = {
            boxSizing: 'border-box',
            paddingLeft: gutterWidth / 2,
            paddingRight: gutterWidth / 2,
            flexShrink: 0
          }; // <Col width={6}>col</Col>

          if (_this.props.width) {
            if (_this.props.width === 'auto') {
              style.flexBasis = 'auto';
              style.flexGrow = 0;
              style.width = 'auto';
              style.maxWidth = 'none';
            } else {
              style.flexBasis = getWidth(_this.props.width, columns) || style.flexBasis;
              style.maxWidth = getWidth(_this.props.width, columns) || style.maxWidth;
            }
          }

          var width = {
            xs: _this.props.xs,
            sm: _this.props.sm,
            md: _this.props.md,
            lg: _this.props.lg,
            xl: _this.props.xl,
            xxl: _this.props.xxl
          };
          var _this$props2 = _this.props,
              offset = _this$props2.offset,
              push = _this$props2.push,
              pull = _this$props2.pull;
          var screenClasses = _constants__WEBPACK_IMPORTED_MODULE_3__["SCREEN_CLASSES"];
          screenClasses.forEach(function (size, index) {
            if (screenClasses.indexOf(screenClass) < index) {
              return;
            }

            if (width[size] === true) {
              // <Col sm>col</Col>
              style.flexBasis = 0;
              style.flexGrow = 1;
            } else if (width[size] === 'auto') {
              style.flexBasis = 'auto';
              style.flexGrow = 0;
              style.width = 'auto';
            } else {
              style.flexBasis = getWidth(width[size], columns) || style.flexBasis;
              style.maxWidth = getWidth(width[size], columns) || style.maxWidth;
            }

            style.marginLeft = getWidth(offset[size], columns) || style.marginLeft;
            style.left = getWidth(push[size], columns) || style.left;
            style.right = getWidth(pull[size], columns) || style.right;
          });
          var hasWidth = !!getWidth(_this.props.width) || Object.keys(width).reduce(function (acc, cur) {
            return acc || width[cur];
          }, false);

          if (!hasWidth) {
            style.flexBasis = 0;
            style.flexGrow = 1;
            style.maxWidth = '100%';
          }

          return flexboxAutoprefixer(style);
        });

        return _this;
      }

      _createClass(Col, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props3 = this.props,
              width = _this$props3.width,
              xs = _this$props3.xs,
              sm = _this$props3.sm,
              md = _this$props3.md,
              lg = _this$props3.lg,
              xl = _this$props3.xl,
              xxl = _this$props3.xxl,
              offset = _this$props3.offset,
              pull = _this$props3.pull,
              push = _this$props3.push,
              className = _this$props3.className,
              style = _this$props3.style,
              children = _this$props3.children,
              props = _objectWithoutProperties(_this$props3, ["width", "xs", "sm", "md", "lg", "xl", "xxl", "offset", "pull", "push", "className", "style", "children"]);

          return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_Resolver__WEBPACK_IMPORTED_MODULE_4__["default"], null, function (_ref3) {
            var _cx;

            var config = _ref3.config,
                screenClass = _ref3.screenClass;
            var columns = config.columns,
                gutterWidth = config.gutterWidth,
                layout = config.layout;
            var colStyle = {};

            if (layout === _constants__WEBPACK_IMPORTED_MODULE_3__["LAYOUT_FLEXBOX"]) {
              colStyle = _this2.getFlexboxStyle({
                columns: columns,
                gutterWidth: gutterWidth,
                screenClass: screenClass
              });
            }

            if (layout === _constants__WEBPACK_IMPORTED_MODULE_3__["LAYOUT_FLOATS"]) {
              colStyle = _this2.getFloatsStyle({
                columns: columns,
                gutterWidth: gutterWidth,
                screenClass: screenClass
              });
            }

            return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement("div", _extends({}, props, {
              className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, (_cx = {}, _defineProperty(_cx, _index_styl__WEBPACK_IMPORTED_MODULE_5___default.a.flexboxCol, layout === _constants__WEBPACK_IMPORTED_MODULE_3__["LAYOUT_FLEXBOX"]), _defineProperty(_cx, _index_styl__WEBPACK_IMPORTED_MODULE_5___default.a.floatsCol, layout === _constants__WEBPACK_IMPORTED_MODULE_3__["LAYOUT_FLOATS"]), _cx)),
              style: _objectSpread({}, colStyle, {}, style)
            }), children);
          });
        }
      }]);

      return Col;
    }(react__WEBPACK_IMPORTED_MODULE_2__["Component"]);

    _defineProperty(Col, "propTypes", {
      // The width of the column for all screen classes.
      width: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
      // The width of the column for screen class `xs`.
      xs: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
      // The width of the column for screen class `sm`.
      sm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
      // The width of the column for screen class `md`.
      md: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
      // The width of the column for screen class `lg`.
      lg: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
      // The width of the column for screen class `xl`.
      xl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
      // The width of the column for screen class `xxl`.
      xxl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
      // The offset of this column for all screen classes.
      offset: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
        xs: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        sm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        md: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        lg: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        xl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        xxl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
      }),
      // The amount this column is pulled to the left for all screen classes.
      pull: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
        xs: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        sm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        md: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        lg: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        xl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        xxl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
      }),
      // The amount this column is pushed to the right for all screen classes.
      push: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
        xs: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        sm: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        md: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        lg: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        xl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
        xxl: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number
      })
    });

    _defineProperty(Col, "defaultProps", {
      offset: {},
      push: {},
      pull: {}
    });
    /* harmony default export */


    __webpack_exports__["default"] = Col;
    /***/
  },

  /***/
  "./src/Container.jsx":
  /*!***************************!*\
    !*** ./src/Container.jsx ***!
    \***************************/

  /*! exports provided: default */

  /***/
  function srcContainerJsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! classnames */
    "classnames");
    /* harmony import */


    var classnames__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var ensure_array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! ensure-array */
    "ensure-array");
    /* harmony import */


    var ensure_array__WEBPACK_IMPORTED_MODULE_1___default =
    /*#__PURE__*/
    __webpack_require__.n(ensure_array__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! prop-types */
    "prop-types");
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_2___default =
    /*#__PURE__*/
    __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_3___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
    /* harmony import */


    var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
    /*! ./constants */
    "./src/constants.js");
    /* harmony import */


    var _Resolver__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
    /*! ./Resolver */
    "./src/Resolver.jsx");
    /* harmony import */


    var _context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
    /*! ./context */
    "./src/context.js");
    /* harmony import */


    var _index_styl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
    /*! ./index.styl */
    "./src/index.styl");
    /* harmony import */


    var _index_styl__WEBPACK_IMPORTED_MODULE_7___default =
    /*#__PURE__*/
    __webpack_require__.n(_index_styl__WEBPACK_IMPORTED_MODULE_7__);

    function _typeof(obj) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
          return typeof obj;
        };
      } else {
        _typeof = function _typeof(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }

      return _typeof(obj);
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);

      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
      }

      return keys;
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};

        if (i % 2) {
          ownKeys(source, true).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(source).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }

      return target;
    }

    function _objectWithoutProperties(source, excluded) {
      if (source == null) return {};

      var target = _objectWithoutPropertiesLoose(source, excluded);

      var key, i;

      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
          target[key] = source[key];
        }
      }

      return target;
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var Container =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(Container, _PureComponent);

      function Container() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Container);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Container)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "getStyle", function (_ref) {
          var containerWidths = _ref.containerWidths,
              gutterWidth = _ref.gutterWidth,
              screenClass = _ref.screenClass;
          var style = {
            paddingLeft: gutterWidth / 2,
            paddingRight: gutterWidth / 2
          };
          var _this$props = _this.props,
              fluid = _this$props.fluid,
              xs = _this$props.xs,
              sm = _this$props.sm,
              md = _this$props.md,
              lg = _this$props.lg,
              xl = _this$props.xl,
              xxl = _this$props.xxl;

          if (fluid && !sm && !md && !lg && !xl && !xxl) {
            return style;
          }

          containerWidths = ensure_array__WEBPACK_IMPORTED_MODULE_1___default()(containerWidths);

          if (screenClass === 'sm' && containerWidths[0] > 0 && !sm && !xs) {
            style.maxWidth = "".concat(containerWidths[0], "px");
          }

          if (screenClass === 'md' && containerWidths[1] > 0 && !md) {
            style.maxWidth = "".concat(containerWidths[1], "px");
          }

          if (screenClass === 'lg' && containerWidths[2] > 0 && !lg) {
            style.maxWidth = "".concat(containerWidths[2], "px");
          }

          if (screenClass === 'xl' && containerWidths[3] > 0 && !xl) {
            style.maxWidth = "".concat(containerWidths[3], "px");
          }

          if (screenClass === 'xxl' && containerWidths[4] > 0 && !xxl) {
            style.maxWidth = "".concat(containerWidths[4], "px");
          }

          return style;
        });

        return _this;
      }

      _createClass(Container, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props2 = this.props,
              fluid = _this$props2.fluid,
              xs = _this$props2.xs,
              sm = _this$props2.sm,
              md = _this$props2.md,
              lg = _this$props2.lg,
              xl = _this$props2.xl,
              xxl = _this$props2.xxl,
              _columns = _this$props2.columns,
              _gutterWidth = _this$props2.gutterWidth,
              _layout = _this$props2.layout,
              className = _this$props2.className,
              style = _this$props2.style,
              children = _this$props2.children,
              props = _objectWithoutProperties(_this$props2, ["fluid", "xs", "sm", "md", "lg", "xl", "xxl", "columns", "gutterWidth", "layout", "className", "style", "children"]);

          return react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_Resolver__WEBPACK_IMPORTED_MODULE_5__["default"], null, function (_ref2) {
            var _cx;

            var config = _ref2.config,
                screenClass = _ref2.screenClass;
            config = _objectSpread({}, config);

            var containerWidths = function () {
              var containerWidths = ensure_array__WEBPACK_IMPORTED_MODULE_1___default()(config.containerWidths);
              return containerWidths.length > 0 ? containerWidths : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_CONTAINER_WIDTHS"];
            }();

            var columns = function () {
              var _this2$props$columns = _this2.props.columns,
                  columns = _this2$props$columns === void 0 ? config.columns : _this2$props$columns;
              return Number(columns) > 0 ? Number(columns) : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_COLUMNS"];
            }();

            var gutterWidth = function () {
              var _this2$props$gutterWi = _this2.props.gutterWidth,
                  gutterWidth = _this2$props$gutterWi === void 0 ? config.gutterWidth : _this2$props$gutterWi;
              return Number(gutterWidth) >= 0 ? Number(gutterWidth) || 0 : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_GUTTER_WIDTH"];
            }();

            var layout = function () {
              var _this2$props$layout = _this2.props.layout,
                  layout = _this2$props$layout === void 0 ? config.layout : _this2$props$layout;
              return _constants__WEBPACK_IMPORTED_MODULE_4__["LAYOUTS"].indexOf(layout) >= 0 ? layout : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_LAYOUT"];
            }();

            var containerStyle = _this2.getStyle({
              containerWidths: containerWidths,
              gutterWidth: gutterWidth,
              screenClass: screenClass
            });

            return react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_context__WEBPACK_IMPORTED_MODULE_6__["ConfigurationContext"].Provider, {
              value: _objectSpread({}, config, {
                containerWidths: containerWidths,
                columns: columns,
                gutterWidth: gutterWidth,
                layout: layout
              })
            }, react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement("div", _extends({}, props, {
              className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, (_cx = {}, _defineProperty(_cx, _index_styl__WEBPACK_IMPORTED_MODULE_7___default.a.flexboxContainer, layout === _constants__WEBPACK_IMPORTED_MODULE_4__["LAYOUT_FLEXBOX"]), _defineProperty(_cx, _index_styl__WEBPACK_IMPORTED_MODULE_7___default.a.floatsContainer, layout === _constants__WEBPACK_IMPORTED_MODULE_4__["LAYOUT_FLOATS"]), _cx)),
              style: _objectSpread({}, containerStyle, {}, style)
            }), children));
          });
        }
      }]);

      return Container;
    }(react__WEBPACK_IMPORTED_MODULE_3__["PureComponent"]);

    _defineProperty(Container, "propTypes", {
      // True makes the container full-width, false fixed-width.
      fluid: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
      // This is in combination with fluid enabled.
      // True makes container fluid only in xs, not present means fluid everywhere.
      xs: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
      // This is in combination with fluid enabled.
      // True makes container fluid only in sm, not present means fluid everywhere.
      sm: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
      // This is in combination with fluid enabled.
      // True makes container fluid only in md, not present means fluid everywhere.
      md: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
      // This is in combination with fluid enabled.
      // True makes container fluid only in lg, not present means fluid everywhere.
      lg: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
      // This is in combination with fluid enabled.
      // True makes container fluid only in xl, not present means fluid everywhere.
      xl: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
      // This is in combination with fluid enabled.
      // True makes container fluid only in xxl, not present means fluid everywhere.
      xxl: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
      // The number of columns.
      columns: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
      // The horizontal padding (called gutter) between two columns.
      gutterWidth: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
      // The grid system layout.
      layout: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(_constants__WEBPACK_IMPORTED_MODULE_4__["LAYOUTS"])
    });

    _defineProperty(Container, "defaultProps", {
      fluid: false,
      xs: false,
      sm: false,
      md: false,
      lg: false,
      xl: false,
      xxl: false
    });
    /* harmony default export */


    __webpack_exports__["default"] = Container;
    /***/
  },

  /***/
  "./src/Hidden.jsx":
  /*!************************!*\
    !*** ./src/Hidden.jsx ***!
    \************************/

  /*! exports provided: default */

  /***/
  function srcHiddenJsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! prop-types */
    "prop-types");
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var _Resolver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! ./Resolver */
    "./src/Resolver.jsx");

    var hidden = function hidden(screenClass, _ref) {
      var xs = _ref.xs,
          sm = _ref.sm,
          md = _ref.md,
          lg = _ref.lg,
          xl = _ref.xl,
          xxl = _ref.xxl;

      if (screenClass === 'xxl') {
        return !!xxl;
      }

      if (screenClass === 'xl') {
        return !!xl;
      }

      if (screenClass === 'lg') {
        return !!lg;
      }

      if (screenClass === 'md') {
        return !!md;
      }

      if (screenClass === 'sm') {
        return !!sm;
      }

      if (screenClass === 'xs') {
        return !!xs;
      }

      return true; // Defaults to true
    };

    var Hidden = function Hidden(_ref2) {
      var xs = _ref2.xs,
          sm = _ref2.sm,
          md = _ref2.md,
          lg = _ref2.lg,
          xl = _ref2.xl,
          xxl = _ref2.xxl,
          children = _ref2.children;
      return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Resolver__WEBPACK_IMPORTED_MODULE_2__["default"], null, function (_ref3) {
        var screenClass = _ref3.screenClass;

        if (hidden(screenClass, {
          xs: xs,
          sm: sm,
          md: md,
          lg: lg,
          xl: xl,
          xxl: xxl
        })) {
          return null;
        }

        return children;
      });
    };

    Hidden.propTypes = {
      // Hidden on extra small devices.
      xs: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Hidden on small devices.
      sm: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Hidden on medium devices.
      md: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Hidden on large devices.
      lg: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Hidden on extra large devices.
      xl: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Hidden on double extra large devices.
      xxl: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool
    };
    Hidden.defaultProps = {
      xs: false,
      sm: false,
      md: false,
      lg: false,
      xl: false,
      xxl: false
    };
    /* harmony default export */

    __webpack_exports__["default"] = Hidden;
    /***/
  },

  /***/
  "./src/Provider.jsx":
  /*!**************************!*\
    !*** ./src/Provider.jsx ***!
    \**************************/

  /*! exports provided: default */

  /***/
  function srcProviderJsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var ensure_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! ensure-array */
    "ensure-array");
    /* harmony import */


    var ensure_array__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(ensure_array__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var lodash_throttle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! lodash.throttle */
    "lodash.throttle");
    /* harmony import */


    var lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default =
    /*#__PURE__*/
    __webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! prop-types */
    "prop-types");
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_2___default =
    /*#__PURE__*/
    __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_3___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
    /* harmony import */


    var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
    /*! ./constants */
    "./src/constants.js");
    /* harmony import */


    var _context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
    /*! ./context */
    "./src/context.js");
    /* harmony import */


    var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
    /*! ./utils */
    "./src/utils.js");

    function _typeof(obj) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
          return typeof obj;
        };
      } else {
        _typeof = function _typeof(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }

      return _typeof(obj);
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var Provider =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(Provider, _PureComponent);

      function Provider(props) {
        var _this;

        _classCallCheck(this, Provider);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props));

        _defineProperty(_assertThisInitialized(_this), "setScreenClass", function () {
          var breakpoints = _this.props.breakpoints;
          var screenClass = Object(_utils__WEBPACK_IMPORTED_MODULE_6__["getScreenClass"])({
            breakpoints: breakpoints
          });

          if (screenClass !== _this.state.screenClass) {
            _this.setState({
              screenClass: screenClass
            });
          }
        });

        _this.state = {
          screenClass: _constants__WEBPACK_IMPORTED_MODULE_4__["SCREEN_CLASSES"][0]
        };
        return _this;
      }

      _createClass(Provider, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.setScreenClass();
          this.eventListener = lodash_throttle__WEBPACK_IMPORTED_MODULE_1___default()(this.setScreenClass, Math.floor(1000 / 60)); // 60Hz

          window.addEventListener('resize', this.eventListener);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this.eventListener) {
            this.eventListener.cancel();
            window.removeEventListener('resize', this.eventListener);
            this.eventListener = null;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;

          var breakpoints = function () {
            var breakpoints = ensure_array__WEBPACK_IMPORTED_MODULE_0___default()(_this2.props.breakpoints);
            return breakpoints.length > 0 ? breakpoints : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_BREAKPOINTS"];
          }();

          var containerWidths = function () {
            var containerWidths = ensure_array__WEBPACK_IMPORTED_MODULE_0___default()(_this2.props.containerWidths);
            return containerWidths.length > 0 ? containerWidths : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_CONTAINER_WIDTHS"];
          }();

          var columns = function () {
            var columns = Number(_this2.props.columns) || 0;
            return columns > 0 ? columns : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_COLUMNS"];
          }();

          var gutterWidth = function () {
            var gutterWidth = Number(_this2.props.gutterWidth) || 0;
            return gutterWidth >= 0 ? gutterWidth : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_GUTTER_WIDTH"];
          }();

          var layout = function () {
            var layout = _this2.props.layout;
            return _constants__WEBPACK_IMPORTED_MODULE_4__["LAYOUTS"].indexOf(layout) >= 0 ? layout : _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_LAYOUT"];
          }();

          var screenClass = this.state.screenClass;
          return react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_context__WEBPACK_IMPORTED_MODULE_5__["ConfigurationContext"].Provider, {
            value: {
              breakpoints: breakpoints,
              containerWidths: containerWidths,
              columns: columns,
              gutterWidth: gutterWidth,
              layout: layout
            }
          }, react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(_context__WEBPACK_IMPORTED_MODULE_5__["ScreenClassContext"].Provider, {
            value: screenClass
          }, react__WEBPACK_IMPORTED_MODULE_3___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_3___default.a.Fragment, null, this.props.children)));
        }
      }]);

      return Provider;
    }(react__WEBPACK_IMPORTED_MODULE_3__["PureComponent"]);

    _defineProperty(Provider, "propTypes", {
      // The breakpoints (minimum width) of devices in screen class sm, md, lg, xl, and xxl.
      breakpoints: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number),
      // The container widths in pixels of devices in screen class sm, md, lg, xl, and xxl.
      containerWidths: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number),
      // The number of columns. Defaults to 12.
      columns: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
      // The horizontal padding (called gutter) between two columns. A gutter width of 30 means 15px on each side of a column.
      gutterWidth: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
      // The grid system layout. One of: 'flexbox', 'floats'
      layout: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(_constants__WEBPACK_IMPORTED_MODULE_4__["LAYOUTS"]),
      // A callback invoked when the resize event occurs.
      onResize: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func
    });

    _defineProperty(Provider, "defaultProps", {
      breakpoints: _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_BREAKPOINTS"],
      containerWidths: _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_CONTAINER_WIDTHS"],
      columns: _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_COLUMNS"],
      gutterWidth: _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_GUTTER_WIDTH"],
      layout: _constants__WEBPACK_IMPORTED_MODULE_4__["DEFAULT_LAYOUT"],
      onResize: function onResize() {}
    });
    /* harmony default export */


    __webpack_exports__["default"] = Provider;
    /***/
  },

  /***/
  "./src/Resolver.jsx":
  /*!**************************!*\
    !*** ./src/Resolver.jsx ***!
    \**************************/

  /*! exports provided: default */

  /***/
  function srcResolverJsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! prop-types */
    "prop-types");
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var _Provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! ./Provider */
    "./src/Provider.jsx");
    /* harmony import */


    var _context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
    /*! ./context */
    "./src/context.js");

    function _typeof(obj) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
          return typeof obj;
        };
      } else {
        _typeof = function _typeof(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }

      return _typeof(obj);
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var Resolver =
    /*#__PURE__*/
    function (_Component) {
      _inherits(Resolver, _Component);

      function Resolver() {
        _classCallCheck(this, Resolver);

        return _possibleConstructorReturn(this, _getPrototypeOf(Resolver).apply(this, arguments));
      }

      _createClass(Resolver, [{
        key: "render",
        value: function render() {
          var children = this.props.children;
          return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_context__WEBPACK_IMPORTED_MODULE_3__["ConfigurationContext"].Consumer, null, function (config) {
            return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_context__WEBPACK_IMPORTED_MODULE_3__["ScreenClassContext"].Consumer, null, function (screenClass) {
              if (!screenClass) {
                return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Provider__WEBPACK_IMPORTED_MODULE_2__["default"], null, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_context__WEBPACK_IMPORTED_MODULE_3__["ConfigurationContext"].Consumer, null, function (config) {
                  return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_context__WEBPACK_IMPORTED_MODULE_3__["ScreenClassContext"].Consumer, null, function (screenClass) {
                    return children({
                      config: config,
                      screenClass: screenClass
                    });
                  });
                }));
              }

              return children({
                config: config,
                screenClass: screenClass
              });
            });
          });
        }
      }]);

      return Resolver;
    }(react__WEBPACK_IMPORTED_MODULE_1__["Component"]);

    _defineProperty(Resolver, "propTypes", {
      children: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func.isRequired
    });
    /* harmony default export */


    __webpack_exports__["default"] = Resolver;
    /***/
  },

  /***/
  "./src/Row.jsx":
  /*!*********************!*\
    !*** ./src/Row.jsx ***!
    \*********************/

  /*! exports provided: default */

  /***/
  function srcRowJsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! classnames */
    "classnames");
    /* harmony import */


    var classnames__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! ./constants */
    "./src/constants.js");
    /* harmony import */


    var _Resolver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
    /*! ./Resolver */
    "./src/Resolver.jsx");
    /* harmony import */


    var _index_styl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
    /*! ./index.styl */
    "./src/index.styl");
    /* harmony import */


    var _index_styl__WEBPACK_IMPORTED_MODULE_4___default =
    /*#__PURE__*/
    __webpack_require__.n(_index_styl__WEBPACK_IMPORTED_MODULE_4__);

    function _typeof(obj) {
      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function _typeof(obj) {
          return typeof obj;
        };
      } else {
        _typeof = function _typeof(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }

      return _typeof(obj);
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);

      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
      }

      return keys;
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};

        if (i % 2) {
          ownKeys(source, true).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(source).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }

      return target;
    }

    function _objectWithoutProperties(source, excluded) {
      if (source == null) return {};

      var target = _objectWithoutPropertiesLoose(source, excluded);

      var key, i;

      if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

        for (i = 0; i < sourceSymbolKeys.length; i++) {
          key = sourceSymbolKeys[i];
          if (excluded.indexOf(key) >= 0) continue;
          if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
          target[key] = source[key];
        }
      }

      return target;
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
      if (source == null) return {};
      var target = {};
      var sourceKeys = Object.keys(source);
      var key, i;

      for (i = 0; i < sourceKeys.length; i++) {
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
      }

      return target;
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var Row =
    /*#__PURE__*/
    function (_PureComponent) {
      _inherits(Row, _PureComponent);

      function Row() {
        var _getPrototypeOf2;

        var _this;

        _classCallCheck(this, Row);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Row)).call.apply(_getPrototypeOf2, [this].concat(args)));

        _defineProperty(_assertThisInitialized(_this), "getStyle", function (_ref) {
          var gutterWidth = _ref.gutterWidth;
          var style = {
            marginLeft: -(gutterWidth / 2),
            marginRight: -(gutterWidth / 2)
          };
          return style;
        });

        return _this;
      }

      _createClass(Row, [{
        key: "render",
        value: function render() {
          var _this2 = this;

          var _this$props = this.props,
              className = _this$props.className,
              style = _this$props.style,
              children = _this$props.children,
              props = _objectWithoutProperties(_this$props, ["className", "style", "children"]);

          return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Resolver__WEBPACK_IMPORTED_MODULE_3__["default"], null, function (_ref2) {
            var _cx;

            var config = _ref2.config,
                screenClass = _ref2.screenClass;
            var gutterWidth = config.gutterWidth,
                layout = config.layout;

            var rowStyle = _this2.getStyle({
              gutterWidth: gutterWidth
            });

            return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", _extends({}, props, {
              className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, (_cx = {}, _defineProperty(_cx, _index_styl__WEBPACK_IMPORTED_MODULE_4___default.a.flexboxRow, layout === _constants__WEBPACK_IMPORTED_MODULE_2__["LAYOUT_FLEXBOX"]), _defineProperty(_cx, _index_styl__WEBPACK_IMPORTED_MODULE_4___default.a.floatsRow, layout === _constants__WEBPACK_IMPORTED_MODULE_2__["LAYOUT_FLOATS"]), _cx)),
              style: _objectSpread({}, rowStyle, {}, style)
            }), children);
          });
        }
      }]);

      return Row;
    }(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]);
    /* harmony default export */


    __webpack_exports__["default"] = Row;
    /***/
  },

  /***/
  "./src/ScreenClass.jsx":
  /*!*****************************!*\
    !*** ./src/ScreenClass.jsx ***!
    \*****************************/

  /*! exports provided: default */

  /***/
  function srcScreenClassJsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! prop-types */
    "prop-types");
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var _Resolver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! ./Resolver */
    "./src/Resolver.jsx");

    var ScreenClass = function ScreenClass(_ref) {
      var render = _ref.render,
          children = _ref.children;
      return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Resolver__WEBPACK_IMPORTED_MODULE_2__["default"], null, function (_ref2) {
        var screenClass = _ref2.screenClass;

        if (typeof children === 'function') {
          return children(screenClass);
        }

        if (typeof render === 'function') {
          return render(screenClass);
        }

        return children;
      });
    };

    ScreenClass.propTypes = {
      render: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.func
    };
    /* harmony default export */

    __webpack_exports__["default"] = ScreenClass;
    /***/
  },

  /***/
  "./src/Visible.jsx":
  /*!*************************!*\
    !*** ./src/Visible.jsx ***!
    \*************************/

  /*! exports provided: default */

  /***/
  function srcVisibleJsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! prop-types */
    "prop-types");
    /* harmony import */


    var prop_types__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_1___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var _Resolver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! ./Resolver */
    "./src/Resolver.jsx");

    var visible = function visible(screenClass, _ref) {
      var xs = _ref.xs,
          sm = _ref.sm,
          md = _ref.md,
          lg = _ref.lg,
          xl = _ref.xl,
          xxl = _ref.xxl;

      if (screenClass === 'xxl') {
        return !!xxl;
      }

      if (screenClass === 'xl') {
        return !!xl;
      }

      if (screenClass === 'lg') {
        return !!lg;
      }

      if (screenClass === 'md') {
        return !!md;
      }

      if (screenClass === 'sm') {
        return !!sm;
      }

      if (screenClass === 'xs') {
        return !!xs;
      }

      return true; // Defaults to true
    };

    var Visible = function Visible(_ref2) {
      var xs = _ref2.xs,
          sm = _ref2.sm,
          md = _ref2.md,
          lg = _ref2.lg,
          xl = _ref2.xl,
          xxl = _ref2.xxl,
          children = _ref2.children;
      return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_Resolver__WEBPACK_IMPORTED_MODULE_2__["default"], null, function (_ref3) {
        var screenClass = _ref3.screenClass;

        if (visible(screenClass, {
          xs: xs,
          sm: sm,
          md: md,
          lg: lg,
          xl: xl,
          xxl: xxl
        })) {
          return children;
        }

        return null;
      });
    };

    Visible.propTypes = {
      // Visible on extra small devices.
      xs: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Visible on small devices.
      sm: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Visible on medimum devices.
      md: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Visible on large devices.
      lg: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Visible on extra large devices.
      xl: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool,
      // Visible on double extra large devices.
      xxl: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.bool
    };
    Visible.defaultProps = {
      xs: false,
      sm: false,
      md: false,
      lg: false,
      xl: false,
      xxl: false
    };
    /* harmony default export */

    __webpack_exports__["default"] = Visible;
    /***/
  },

  /***/
  "./src/constants.js":
  /*!**************************!*\
    !*** ./src/constants.js ***!
    \**************************/

  /*! exports provided: LAYOUT_FLEXBOX, LAYOUT_FLOATS, LAYOUTS, SCREEN_CLASSES, DEFAULT_BREAKPOINTS, DEFAULT_CONTAINER_WIDTHS, DEFAULT_COLUMNS, DEFAULT_GUTTER_WIDTH, DEFAULT_LAYOUT */

  /***/
  function srcConstantsJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "LAYOUT_FLEXBOX", function () {
      return LAYOUT_FLEXBOX;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "LAYOUT_FLOATS", function () {
      return LAYOUT_FLOATS;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "LAYOUTS", function () {
      return LAYOUTS;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "SCREEN_CLASSES", function () {
      return SCREEN_CLASSES;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "DEFAULT_BREAKPOINTS", function () {
      return DEFAULT_BREAKPOINTS;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "DEFAULT_CONTAINER_WIDTHS", function () {
      return DEFAULT_CONTAINER_WIDTHS;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "DEFAULT_COLUMNS", function () {
      return DEFAULT_COLUMNS;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "DEFAULT_GUTTER_WIDTH", function () {
      return DEFAULT_GUTTER_WIDTH;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "DEFAULT_LAYOUT", function () {
      return DEFAULT_LAYOUT;
    });

    var LAYOUT_FLEXBOX = 'flexbox';
    var LAYOUT_FLOATS = 'floats';
    var LAYOUTS = [LAYOUT_FLEXBOX, LAYOUT_FLOATS];
    var SCREEN_CLASSES = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']; // The default breakpoints (minimum width) of devices in screen class sm, md, lg, xl, and xxl.

    var DEFAULT_BREAKPOINTS = [576, 768, 992, 1200, 0]; // The default container widths in pixels of devices in screen class sm, md, lg, xl, and xxl.

    var DEFAULT_CONTAINER_WIDTHS = [540, 720, 960, 1140, 0]; // The default number of columns.

    var DEFAULT_COLUMNS = 12; // The default horizontal padding (called gutter) between two columns. A gutter width of 30 means 15px on each side of a column.

    var DEFAULT_GUTTER_WIDTH = 0; // The default grid system layout.

    var DEFAULT_LAYOUT = LAYOUT_FLEXBOX;
    /***/
  },

  /***/
  "./src/context.js":
  /*!************************!*\
    !*** ./src/context.js ***!
    \************************/

  /*! exports provided: ConfigurationContext, ScreenClassContext */

  /***/
  function srcContextJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "ConfigurationContext", function () {
      return ConfigurationContext;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "ScreenClassContext", function () {
      return ScreenClassContext;
    });
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! react */
    "react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! ./constants */
    "./src/constants.js");

    var ConfigurationContext = react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({
      breakpoints: _constants__WEBPACK_IMPORTED_MODULE_1__["DEFAULT_BREAKPOINTS"],
      containerWidths: _constants__WEBPACK_IMPORTED_MODULE_1__["DEFAULT_CONTAINER_WIDTHS"],
      columns: _constants__WEBPACK_IMPORTED_MODULE_1__["DEFAULT_COLUMNS"],
      gutterWidth: _constants__WEBPACK_IMPORTED_MODULE_1__["DEFAULT_GUTTER_WIDTH"],
      layout: _constants__WEBPACK_IMPORTED_MODULE_1__["DEFAULT_LAYOUT"]
    });
    var ScreenClassContext = react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext(null);
    /***/
  },

  /***/
  "./src/index.js":
  /*!**********************!*\
    !*** ./src/index.js ***!
    \**********************/

  /*! exports provided: Provider, Container, Row, Col, Hidden, Visible, ScreenClass */

  /***/
  function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */


    var _Provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! ./Provider */
    "./src/Provider.jsx");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "Provider", function () {
      return _Provider__WEBPACK_IMPORTED_MODULE_0__["default"];
    });
    /* harmony import */


    var _Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! ./Container */
    "./src/Container.jsx");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "Container", function () {
      return _Container__WEBPACK_IMPORTED_MODULE_1__["default"];
    });
    /* harmony import */


    var _Row__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
    /*! ./Row */
    "./src/Row.jsx");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "Row", function () {
      return _Row__WEBPACK_IMPORTED_MODULE_2__["default"];
    });
    /* harmony import */


    var _Col__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
    /*! ./Col */
    "./src/Col.jsx");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "Col", function () {
      return _Col__WEBPACK_IMPORTED_MODULE_3__["default"];
    });
    /* harmony import */


    var _Hidden__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
    /*! ./Hidden */
    "./src/Hidden.jsx");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "Hidden", function () {
      return _Hidden__WEBPACK_IMPORTED_MODULE_4__["default"];
    });
    /* harmony import */


    var _Visible__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
    /*! ./Visible */
    "./src/Visible.jsx");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "Visible", function () {
      return _Visible__WEBPACK_IMPORTED_MODULE_5__["default"];
    });
    /* harmony import */


    var _ScreenClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
    /*! ./ScreenClass */
    "./src/ScreenClass.jsx");
    /* harmony reexport (safe) */


    __webpack_require__.d(__webpack_exports__, "ScreenClass", function () {
      return _ScreenClass__WEBPACK_IMPORTED_MODULE_6__["default"];
    });
    /***/

  },

  /***/
  "./src/index.styl":
  /*!************************!*\
    !*** ./src/index.styl ***!
    \************************/

  /*! no static exports found */

  /***/
  function srcIndexStyl(module, exports, __webpack_require__) {
    // extracted by mini-css-extract-plugin
    module.exports = {
      "flexbox-container": "grid-system---flexbox-container---3Fao-",
      "flexboxContainer": "grid-system---flexbox-container---3Fao-",
      "floats-container": "grid-system---floats-container---ucGke",
      "floatsContainer": "grid-system---floats-container---ucGke",
      "floats-row": "grid-system---floats-row---3L-46",
      "floatsRow": "grid-system---floats-row---3L-46",
      "flexbox-row": "grid-system---flexbox-row---38uB8",
      "flexboxRow": "grid-system---flexbox-row---38uB8",
      "floats-col": "grid-system---floats-col---LUxzY",
      "floatsCol": "grid-system---floats-col---LUxzY",
      "flexbox-col": "grid-system---flexbox-col---lXegW",
      "flexboxCol": "grid-system---flexbox-col---lXegW"
    };
    /***/
  },

  /***/
  "./src/utils.js":
  /*!**********************!*\
    !*** ./src/utils.js ***!
    \**********************/

  /*! exports provided: getViewportWidth, getScreenClass */

  /***/
  function srcUtilsJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "getViewportWidth", function () {
      return getViewportWidth;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "getScreenClass", function () {
      return getScreenClass;
    });
    /* harmony import */


    var ensure_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
    /*! ensure-array */
    "ensure-array");
    /* harmony import */


    var ensure_array__WEBPACK_IMPORTED_MODULE_0___default =
    /*#__PURE__*/
    __webpack_require__.n(ensure_array__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
    /*! ./constants */
    "./src/constants.js");

    var getViewportWidth = function getViewportWidth() {
      if (typeof window !== 'undefined' && window.innerWidth) {
        return window.innerWidth;
      }

      return null;
    };

    var getScreenClass = function getScreenClass(_ref) {
      var breakpoints = _ref.breakpoints;
      breakpoints = ensure_array__WEBPACK_IMPORTED_MODULE_0___default()(breakpoints);

      if (breakpoints.length === 0) {
        breakpoints = _constants__WEBPACK_IMPORTED_MODULE_1__["DEFAULT_BREAKPOINTS"];
      }

      var screenClass = 'xs';
      var viewportWidth = getViewportWidth();

      if (breakpoints[0] && viewportWidth >= breakpoints[0] && breakpoints[0] > 0) {
        screenClass = 'sm';
      }

      if (breakpoints[1] && viewportWidth >= breakpoints[1] && breakpoints[1] > 0) {
        screenClass = 'md';
      }

      if (breakpoints[2] && viewportWidth >= breakpoints[2] && breakpoints[2] > 0) {
        screenClass = 'lg';
      }

      if (breakpoints[3] && viewportWidth >= breakpoints[3] && breakpoints[3] > 0) {
        screenClass = 'xl';
      }

      if (breakpoints[4] && viewportWidth >= breakpoints[4] && breakpoints[4] > 0) {
        screenClass = 'xxl';
      }

      return screenClass;
    };
    /***/

  },

  /***/
  "classnames":
  /*!*****************************!*\
    !*** external "classnames" ***!
    \*****************************/

  /*! no static exports found */

  /***/
  function classnames(module, exports) {
    module.exports = require("classnames");
    /***/
  },

  /***/
  "ensure-array":
  /*!*******************************!*\
    !*** external "ensure-array" ***!
    \*******************************/

  /*! no static exports found */

  /***/
  function ensureArray(module, exports) {
    module.exports = require("ensure-array");
    /***/
  },

  /***/
  "lodash.throttle":
  /*!**********************************!*\
    !*** external "lodash.throttle" ***!
    \**********************************/

  /*! no static exports found */

  /***/
  function lodashThrottle(module, exports) {
    module.exports = require("lodash.throttle");
    /***/
  },

  /***/
  "prop-types":
  /*!*****************************!*\
    !*** external "prop-types" ***!
    \*****************************/

  /*! no static exports found */

  /***/
  function propTypes(module, exports) {
    module.exports = require("prop-types");
    /***/
  },

  /***/
  "react":
  /*!************************!*\
    !*** external "react" ***!
    \************************/

  /*! no static exports found */

  /***/
  function react(module, exports) {
    module.exports = require("react");
    /***/
  }
  /******/

});